import { useEffect } from 'react';
import useTenantState from '@/states/tenant.state';
import useCompanyState from '@/states/company.state';
import useOrgChartState from '@/states/organization.state';
import useKeyActivityState from '@/states/key-activities.state';

export const useTenantWatcher = () => {
  const { currentTenant } = useTenantState();
  const { clearCompanyProfile } = useCompanyState.getState();
  const { clearOrgCharts } = useOrgChartState.getState();
  const { clearKeyActivities } = useKeyActivityState.getState();

  useEffect(() => {
    clearCompanyProfile?.();
    clearOrgCharts?.();
    clearKeyActivities?.();
  }, [currentTenant?.id]);
};
